export enum TimerStatusEnum {
    Paused = 1,
    Main = 2,
    Expired = 4,
    IsStopped = Paused | Expired,
    IsRunning = Main
}
